export const TRANSLATION_GROUP_ADMIN_WEBHOOKS_DETAILS = Symbol('admin.webhooks.details');
export const TRANSLATION_GROUP_AFFILIATES_WEBHOOKS_DETAILS = Symbol('affiliates.webhooks.details');

export const ADMIN_WEBHOOKS_HISTORY_DETAILS_ROUTE_NAME = Symbol('admin.webhooks-history.details');
export const AFFILIATE_WEBHOOKS_HISTORY_DETAILS_ROUTE_NAME = Symbol('affiliate.webhooks-history.details');

export const WEBHOOKS_DETAILS_QUERY_KEY = 'webhooks-details';
export const WEBHOOKS_HISTORY_DETAILS_API_URL = ':namespace/requests/:id/history';
